export default {
    SET_DOCTOR_ID: (state, title) => {
        state.title = title;
    },
    SET_MESSAGE_TYPE: (state, section) => {
        state.section = section;
    },
    SET_MESSAGE_TIME: (state, units) => {
        state.units = units;
    },
    SET_MESSAGE_TIME_STATE: (state, units) => {
        state.unitsForCurrentUser = units;
    },
    SET_MESSAGE_MOBILES: (state, unit) => {
        state.unit = unit;
    },
    SET_MESSAGE: (state, status) => {
        state.status = status;
    },
    SET_MESSAGE_UNIT: (state, unitToEdit) => {
        state.unitToEdit = unitToEdit;
    },
    SET_MESSAGE_VALUE: (state, total) =>{
        state.total = total
    },
}